export const createPopSound = () => {
  const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  
  const oscillator = audioContext.createOscillator();
  const gainNode1 = audioContext.createGain();
  const gainNode2 = audioContext.createGain();
  
  oscillator.connect(gainNode1);
  gainNode1.connect(gainNode2);
  gainNode2.connect(audioContext.destination);
  
  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(150, audioContext.currentTime);
  oscillator.frequency.exponentialRampToValueAtTime(40, audioContext.currentTime + 0.1);
  
  // Use two gain nodes in series for increased volume
  gainNode1.gain.setValueAtTime(1.0, audioContext.currentTime);
  gainNode2.gain.setValueAtTime(2.0, audioContext.currentTime);
  
  gainNode1.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1);
  gainNode2.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1);
  
  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + 0.1);
}; 